import React, { useEffect, useState } from "react";
import InputMask from "react-input-mask";
import { Save } from "lucide-react";
import PermissoesUsuario, { flagsPadrao } from "./PermissoesUsuario";

const CadastroUsuario = ({ token, initialData = {}, onSubmit, isEdit = false }) => {
  const [usuario, setUsuario] = useState({
    nome: "",
    telefone: "",
    email: "",
    senha: "",
    ...initialData,
  });
  const [permissoes, setPermissoes] = useState(flagsPadrao("admin"));

  useEffect(() => {
    if (initialData && Object.keys(initialData).length > 0) {
      setUsuario({
        nome: initialData.nome || "",
        telefone: initialData.telefone || "",
        email: initialData.email || "",
        senha: "", // nunca pré-carrega senha
      });
      const salvas = initialData.permissoes || initialData.Permissoes;
      setPermissoes(Array.isArray(salvas) && salvas.length ? salvas : flagsPadrao("admin"));
    }
  }, [initialData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUsuario((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const usuarioPayload = {
      Nome: usuario.nome,
      Telefone: usuario.telefone,
      Email: usuario.email,
      // no edit: se vier vazio, backend ignora (ou você trata lá)
      Senha: usuario.senha,
      Permissoes: permissoes,
    };

    try {
      await onSubmit(usuarioPayload, token);
      alert(isEdit ? "Usuário atualizado com sucesso!" : "Usuário cadastrado com sucesso!");
    } catch (err) {
      const data = err?.response?.data;

      if (typeof data === "string") {
        alert(data);
        return;
      }

      const message =
        data?.message ||
        (data?.errors && Object.values(data.errors).flat().join("\n")) ||
        err.message ||
        `Erro ao ${isEdit ? "atualizar" : "cadastrar"} usuário.`;

      alert(message);
      console.error(err);
    }
  };

  const inputClass = `
    w-full px-3 py-2.5 rounded-xl border outline-none transition
    zen-card border-gray-300 text-gray-900 placeholder:text-gray-400
    focus:ring-2 focus:ring-blue-500/60
    dark:bg-slate-950/40 dark:border-white/10 dark:text-white dark:placeholder:text-slate-400
    dark:focus:ring-blue-400/40
  `;

  const labelClass = "block text-sm font-medium text-gray-700 dark:text-slate-200 mb-1";

  return (
    <div className="max-w-2xl mx-auto">
      <div className="zen-card rounded-2xl p-6 md:p-8 shadow-sm dark:backdrop-blur">
        {/* header */}
        <div className="mb-8">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 dark:text-white">
            {isEdit ? "Editar Usuário" : "Cadastro de Usuário"}
          </h2>
          <p className="text-sm text-gray-500 dark:text-slate-300/80 mt-1">
            Preencha os dados para {isEdit ? "editar o" : "cadastrar um novo"} usuário.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="zen-card rounded-2xl p-4 dark:bg-white/5 dark:border-white/10">
            <div className="grid grid-cols-1 gap-4">
              <div>
                <label className={labelClass}>Nome</label>
                <input
                  type="text"
                  name="nome"
                  value={usuario.nome}
                  onChange={handleChange}
                  className={inputClass}
                  required
                />
              </div>

              <div>
                <label className={labelClass}>Telefone</label>
                <InputMask
                  mask="(99) 99999-9999"
                  type="text"
                  name="telefone"
                  value={usuario.telefone}
                  onChange={handleChange}
                  className={inputClass}
                />
              </div>

              <div>
                <label className={labelClass}>Email</label>
                <input
                  type="email"
                  name="email"
                  value={usuario.email}
                  onChange={handleChange}
                  className={inputClass}
                  required
                />
              </div>

              <div>
                <label className={labelClass}>
                  {isEdit ? "Nova Senha (deixe em branco para não alterar)" : "Senha"}
                </label>
                <input
                  type="password"
                  name="senha"
                  value={usuario.senha}
                  onChange={handleChange}
                  className={inputClass}
                  required={!isEdit}
                  placeholder={isEdit ? "•••••••• (opcional)" : ""}
                />
                {isEdit && (
                  <p className="text-xs mt-1 text-gray-500 dark:text-slate-300/70">
                    Se deixar em branco, a senha atual permanece.
                  </p>
                )}
              </div>
            </div>
          </div>

          <PermissoesUsuario audiencia="admin" value={permissoes} onChange={setPermissoes} />

          {/* actions */}
          <div className="flex justify-end pt-2">
            <button
              type="submit"
              className="
                inline-flex items-center gap-2 px-6 py-3 rounded-xl font-semibold text-sm transition
                bg-blue-600 text-white hover:bg-blue-500
              "
            >
              <Save size={18} />
              {isEdit ? "Salvar Alterações" : "Cadastrar Usuário"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CadastroUsuario;
